<template>
	<div class="properties-table">
		<key-dates-table-content :sites="sites" />
	</div>
</template>

<script>
import KeyDatesTableContent from './KeyDatesTableContent.vue';

export default {
	name: 'KeyDatesTabContent',
	
	components: {
		KeyDatesTableContent
	},
	
	props: {
		sites: {
			type: Array,
			required: true
		}
	}
}
</script>
